export default __webpack_public_path__ + "static/media/m-43.5fe5dac5.svg";